import { FormControl, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { SalaryInput } from 'wisestep-base';

const OfferedPayRateField = ({ name }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SalaryInput addTimeField onInputChange={onChange} initialValue={value} />
        )}
      />
      {errors && (
        <>
          {errors.offeredPayRate?.currency && (
            <FormHelperText error>{errors.offeredPayRate.currency.message}</FormHelperText>
          )}
          {errors.offeredPayRate?.value && (
            <FormHelperText error>{errors.offeredPayRate.value.message}</FormHelperText>
          )}
        </>
      )}
    </FormControl>
  );
};

export default OfferedPayRateField;
